<template>
  <div class="hello">
    <div style="display: flex;justify-content: space-between;">
      <div>
        <h3>Ringkasan Transaksi</h3>
      </div>
      <div style="display: flex;align-items: center;">
        <form @submit.prevent="cari">
          <input type="date" v-model="filter.tglAwal"/>
          <input type="date" v-model="filter.tglAkhir"/>
          <input type="submit" value="Filter"/>
        </form>
        &nbsp;
        <button type="button" @click="excel" :disabled="btnDownload.disable">{{ btnDownload.text }}</button>
      </div>
    </div>
    <div class="grid-3 summary">
      <div class="card">
        <h1>{{ summary.totalBill | numeric}}</h1>
        <h3>Total Bill</h3>
      </div>
      <div class="card">
        <h1>{{ summary.totalOrder | numeric }}</h1>
        <h3>Total Omzet</h3>
      </div>
      <div class="card">
        <h1>{{ summary.totalItem | numeric }}</h1>
        <h3>Total Item Terjual</h3>
      </div>
    </div>

    <h3>Transaksi per Outlet <span v-if="loadingOutlet">({{ outlet.length}} dari {{ outletHeader.length }})</span></h3>

    <div
      v-if="loading"
      class="if-loading"
    >
      <div class="loader"></div>
    </div>

    <div class="grid-3 grid-border gap-15">
      <div
        v-for="item in outlet"
        :key="item.id"
        class="card"
      >
        <div>
          <h3>{{ item.nama }}</h3>
          <div class="card-body">
            <div
              v-if="!item.summary.total"
              class="if-loading"
            >
              <div class="loader"></div>
            </div>

            <div v-if="item.summary.total">
              <div class="grid-2">
                <div class="detail">
                  <span>Omzet</span>
                  <label>Rp {{ item.summary.total | numeric }}</label>
                </div>
                <div class="detail">
                  <span>Item terjual</span>
                  <label>{{ item.summary.itemTerjual | numeric }}</label>
                </div>
              </div>
              <div class="item-terjual">
                <span>Item Terjual (Top 8)</span>

                <div class="grid-2 gap-15">
                  <div>
                    <ul>
                      <li v-for="mn in item.summary.top8">
                        <div>{{ mn.menu }}</div>
                        <span>{{ mn.jumlah }}</span>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <PieChart :menu="item.summary.top8" style="width: 250px;"/>
                  </div>
                </div>
              </div>
              <div class="item-terjual">
                <span>Pembayaran</span>

                <div class="grid-2 gap-15">
                  <div>
                    <ul>
                      <li v-for="tipe in item.summary.tipePembayaran">
                        <div>{{ tipe.tipe_pembayaran }}</div>
                        <span>Rp {{ tipe.total | numeric }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import PieChart from '@/components/PieChart'
  import Excel from 'exceljs'
  import {saveAs} from 'file-saver'

  export default {
    name: 'hello',
    components: {
      PieChart
    },
    data () {
      return {
        loading: true,
        loadingOutlet: true,
        summary: {},
        outlet: [],
        outletHeader: [],
        newOutlet: [],
        filter: {
          tglAwal: null,
          tglAkhir: null
        },
        btnDownload: {
          text: 'Download Excel',
          disable: false
        }
      }
    },
    methods: {
      cari () {
        this.outlet = []
        this.outletHeader = []
        this.fetchSummary()
        this.fetchOutlet()
      },
      fetchSummary () {
        const self = this

        let param = {
          id_toko: localStorage.getItem('id_toko')
        }

        if (self.filter.tglAwal && self.filter.tglAkhir) {
          param.tgl_awal = self.filter.tglAwal
          param.tgl_akhir = self.filter.tglAkhir
        }

        self.summary.totalBill = ''
        self.summary.totalOrder = ''
        self.summary.totalItem = ''
        self.summary.totalCustomer = ''

        axios
          .get('http://dashboard.restoku.id/welcome/summaryOrder', {params: param})
          .then((r) => {
            self.summary.totalBill = r.data.total_bill
            self.summary.totalOrder = r.data.total_order
            self.summary.totalItem = r.data.total_item
            self.summary.totalCustomer = r.data.total_customer
          })
      },
      fetchOutlet () {
        axios
          .get('http://dashboard.restoku.id/welcome/getOutlet?id_toko=' + localStorage.getItem('id_toko'))
          .then((r) => {
            this.loading = false

            this.outletHeader = r.data
            // this.renderCard(0, r.data)
            this.fetchSummaryOutlet(0, r.data)
          })
      },
      renderCard (index, item) {
        const self = this
        item[index].summary = {}
        self.outlet.push(item[index])

        if (index <= item.length - 2) {
          setTimeout(() => {
            let newIndex = index + 1
            self.renderCard(newIndex, item)
            self.fetchSummaryOutlet(newIndex, item[newIndex])
          }, 500)
        }
      },
      fetchSummaryOutlet (index, item) {
        const self = this
        if (index <= item.length - 1) {
          let params = {
            id_toko: item[index].id
          }

          if (self.filter.tglAwal && self.filter.tglAkhir) {
            params.tgl_awal = self.filter.tglAwal
            params.tgl_akhir = self.filter.tglAkhir
          }

          axios
            .get('http://dashboard.restoku.id/welcome/getSummaryPerToko', {params: params})
            .then((r) => {
              let top8 = []
              r.data.top_8.forEach((item) => {
                top8.push({
                  id_menu: item.id,
                  jumlah: item.jumlah,
                  menu: item.nama
                })
              })

              item[index].summary = {
                id_toko: item.id,
                total: r.data ? r.data.omzet.total : '0',
                itemTerjual: r.data ? r.data.item_terjual.total : '0',
                top8: top8,
                tipePembayaran: r.data.tipe_pembayaran
              }

              self.outlet.push(item[index])

              setTimeout(() => {
                let newIndex = index + 1
                self.fetchSummaryOutlet(newIndex, item)
              }, 500)
            })
        } else {
          this.loadingOutlet = false
        }
      },
      excel () {
        const self = this
        let params = {
          id_toko: localStorage.getItem('id_toko')
        }

        if (self.filter.tglAwal && self.filter.tglAkhir) {
          params.tgl_awal = self.filter.tglAwal
          params.tgl_akhir = self.filter.tglAkhir
        }

        self.btnDownload.text = 'Processing...'
        self.btnDownload.disable = true

        axios
          .get('http://dashboard.restoku.id/welcome/generateReportExcel', {params: params})
          .then((r) => {
            const workbook = new Excel.Workbook()
            const worksheet = workbook.addWorksheet('LAPORAN')
            const sheet2 = workbook.addWorksheet('ITEM PENJUALAN')

            let columns = [
              {header: 'Tanggal', key: 'tanggal'}
            ]

            this.outletHeader.forEach((item) => {
              columns.push({
                header: item.nama, key: 'toko_' + item.id
              })
            })
            worksheet.columns = columns

            const tgl = Object.keys(r.data)
            tgl.forEach((item) => {
              let row = {
                tanggal: item
              }

              this.outletHeader.forEach((outlet) => {
                if (r.data[item][outlet.id]) {
                  row['toko_' + outlet.id] = parseInt(r.data[item][outlet.id].grand_total)
                } else {
                  row['toko_' + outlet.id] = 0
                }
              })

              worksheet.addRow(row)
            })

            sheet2.columns = [
              { header: 'Outlet', key: 'outlet' },
              { header: 'Tanggal', key: 'tanggal' },
              { header: 'Menu', key: 'menu' },
              { header: 'Harga', key: 'harga' },
              { header: 'Jumlah', key: 'jumlah' },
              { header: 'Total', key: 'total' }
            ]

            axios
              .get('http://dashboard.restoku.id/welcome/generateItemPenjualanExcel', {params: params})
              .then((r) => {
                self.btnDownload.text = 'Download Excel'
                self.btnDownload.disable = false

                r.data.forEach((item) => {
                  sheet2.addRow({
                    outlet: item.outlet,
                    tanggal: item.tanggal,
                    menu: item.menu,
                    harga: item.harga_menu,
                    jumlah: item.jumlah,
                    total: parseInt(item.harga_menu) * parseInt(item.jumlah)
                  })
                })

                workbook.xlsx.writeBuffer('export.xlsx')
                  .then((buffer) => {
                    const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                    saveAs(blob, 'SUMMARY PENJUALAN.xlsx')
                  })
              })
          })
      }
    },
    mounted () {
      this.fetchSummary()
      this.fetchOutlet()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .hello {
    padding: 15px;

    .grid-4 {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-column-gap: 15px;
      margin-bottom: 15px;

      .card {
        background: #fff;
        box-shadow: 0px 3px 3px #ccc;
        border-radius: 4px;
        text-align: center;
      }
    }

    .grid-3 {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      &.summary {
        grid-column-gap: 15px;
        margin-bottom: 15px;

        .card {
          border-radius: 4px;
          text-align: center;
        }
      }

      .card {
        background: #fff;
        border: 1px solid #ccc;
        max-width: 100%;

        > div {

          h3 {
            background: #168BE3;
            color: #fff;
            padding: 10px;
            margin: 0;
            margin-bottom: 15px;
            text-transform: uppercase;
            border: 1px solid #168BE3;
          }

          .card-body {
            margin: 15px;

            .detail {
              margin-bottom: 25px;

              span {
                display: block;
                text-transform: uppercase;
                font-size: 14px;
              }

              label {
                font-weight: 600;
                font-size: 18px;
              }
            }
          }
        }

      }
    }

    .grid-2 {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .item-terjual {
      span {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 14px;
      }

      ul {
        list-style-type: none;
        padding: 0;
        margin-top: 10px;

        li {
          display: flex;
          justify-content: space-between;
          padding-bottom: 10px;
        }
      }
    }

    .gap-15 {
      grid-column-gap: 15px;
      grid-row-gap: 15px;
    }

    .if-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 250px;

      .loader {
        border: 6px solid #f3f3f3; /* Light grey */
        border-top: 6px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 70px;
        height: 70px;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue